// Generate iCalendar (.ics) files so staff can add shifts to
// Apple Calendar / Google Calendar / Outlook with one tap.

const SERVICE_LABELS = {
  day_program: 'Explore Program',
  in_home: 'IHCS',
  employment: 'Employment',
  private_pay: 'Private Pay',
};

// Format a "YYYY-MM-DD" + "HH:MM" pair as a floating local DTSTART/DTEND value.
// Floating (no Z, no TZID) keeps the time as-is in whatever timezone the
// staff's device is in — which is the desired behaviour for a scheduling app.
const toIcsLocal = (dateStr, timeStr) => {
  const [y, m, d] = dateStr.split('-');
  const [hh, mm] = (timeStr || '00:00').split(':');
  return `${y}${m}${d}T${hh.padStart(2, '0')}${mm.padStart(2, '0')}00`;
};

const escape = (s = '') =>
  String(s).replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');

const buildVEvent = (shift) => {
  const summary = `Shift — ${SERVICE_LABELS[shift.service_line] || shift.service_line || 'Work'}`;
  const participants = (shift.participants || []).join(', ');
  const descParts = [];
  if (participants) descParts.push(`Participants: ${participants}`);
  if (shift.notes) descParts.push(shift.notes);
  descParts.push('Sent from The Next Step Programs scheduler');

  const dtstamp = new Date().toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  return [
    'BEGIN:VEVENT',
    `UID:shift-${shift.id}@tnsprograms.org`,
    `DTSTAMP:${dtstamp}`,
    `DTSTART:${toIcsLocal(shift.date, shift.time_in)}`,
    `DTEND:${toIcsLocal(shift.date, shift.time_out)}`,
    `SUMMARY:${escape(summary)}`,
    shift.location ? `LOCATION:${escape(shift.location)}` : null,
    `DESCRIPTION:${escape(descParts.join('\n'))}`,
    'END:VEVENT',
  ].filter(Boolean).join('\r\n');
};

const wrapCalendar = (events) => [
  'BEGIN:VCALENDAR',
  'VERSION:2.0',
  'PRODID:-//The Next Step Programs//Schedule//EN',
  'CALSCALE:GREGORIAN',
  'METHOD:PUBLISH',
  events,
  'END:VCALENDAR',
].join('\r\n');

export const generateShiftIcs = (shift) => wrapCalendar(buildVEvent(shift));

export const generateShiftsIcs = (shifts) =>
  wrapCalendar(shifts.map(buildVEvent).join('\r\n'));

export const downloadIcs = (filename, content) => {
  const blob = new Blob([content], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.ics') ? filename : `${filename}.ics`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
